import { ApActionStatus } from '../enums/ApActionStatus';
import { ApActionType } from '../enums/ApActionType';

export type ApTemplateAction = {
    actionId: number;
    clientId?: number;
    templateId: number;
    parentId?: number;
    status: ApActionStatus;
    dateCreated: Date;
    type: ApActionType;
    title: string;
    subject: string;
    body: string;
    note: string;
    daySpan?: number;
    hourSpan?: number;
    minuteSpan?: number;
    time?: number;
    sort?: number;
    actions: ApTemplateAction[];
};

export type CreateApTemplateActionRequest = {
    parentId?: number;
    type: ApActionType;
    title: string;
    subject: string;
    body: string;
    note: string;
    daySpan?: number;
    hourSpan?: number;
    minuteSpan?: number;
    time?: number;
    sort: number;
};

/**
 * buildCreateApTemplateAction
 *
 * @description
 * Builds an Ap template action object which matches the object expected by the server
 * in a request to create a new Ap template action.
 *
 * @hidden
 * Adds default values for object properties which are optional and not passed in the argument object
 */
export function buildCreateApTemplateAction(args: {
    parentId?: number;
    type: ApActionType;
    title?: string;
    subject?: string;
    body?: string;
    note?: string;
    daySpan?: number;
    hourSpan?: number;
    minuteSpan?: number;
    time?: number;
    sort: number;
}): CreateApTemplateActionRequest {
    return {
        type: args.type,
        title: args.title || `New ${args.type} Action - ${new Date().toLocaleDateString()}`,
        daySpan: args.daySpan || 0,
        time: args.time || 0,
        hourSpan: args.hourSpan || 0,
        minuteSpan: args.minuteSpan || 0,
        note: args.note || '',
        subject: args.subject || '',
        body: args.body || '',
        sort: args.sort,
        parentId: args.parentId,
    };
}

export type UpdateApTemplateActionRequest = {
    parentId?: number;
    status: ApActionStatus;
    type: ApActionType;
    title: string;
    subject: string;
    body: string;
    note: string;
    daySpan?: number;
    hourSpan?: number;
    minuteSpan?: number;
    time?: number;
    sort?: number;
};

/**
 * buildUpdateApTemplateAction
 *
 * @description
 * Builds an object from an existing Ap template action which matches what is expected by the
 * server in a request to update an Ap template action
 */
export function buildUpdateApTemplateAction(
    action: ApTemplateAction,
): UpdateApTemplateActionRequest {
    return {
        parentId: action.parentId,
        status: action.status,
        type: action.type,
        title: action.title,
        subject: action.subject,
        body: action.body,
        note: action.note,
        daySpan: action.daySpan,
        hourSpan: action.hourSpan,
        minuteSpan: action.minuteSpan,
        time: action.time,
        sort: action.sort,
    };
}
